import React, { Component } from 'react';
import BackButton from 'components/BackButton';
import ProfileItem from 'components/Profile/ProfileItem';
import getPCRating from 'utils/get-pc-rating';
import i18n from 'i18n';

import {
  StyledProfileButtonsWrapper,
  StyledSettingsPage,
  StyledSettingsPageTitle,
} from 'components/Profile/StyledComponents';
import Clock from 'components/Clock';
import { SupportInfo } from 'components/SupportInfo';

export default class ParentalLockPage extends Component {
  componentWillUnmount() {
    if (this.props.show) {
      this.props.hideToast();
    }
  }

  onBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  onEnter = item => {
    const { history, match } = this.props;

    history.push(`${match.url}/${item.path}`);
  };

  getParentalListData = () => {
    const { parentalData } = this.props;
    const { parentalLockItems } = this.props;

    const data = {
      age: (parentalData && getPCRating(parentalData.age)).age || getPCRating('G').age,
      purchase: parentalData && parentalData.purchase ? i18n.t('pc.on') : i18n.t('pc.off'),
      pin: (parentalData && parentalData.pinCode) || '-',
    };

    const parentalList = parentalLockItems.map(item => {
      // TODO сделать нормальную логику
      if (item.value !== 'pin') {
        item.metadata = data[item.value];
      }
      return item;
    });

    return parentalList;
  };

  render() {
    const parentalListData = this.getParentalListData();

    return (
      <StyledSettingsPage>
        <BackButton onEnter={this.onBack} />
        <Clock />
        <StyledSettingsPageTitle>{i18n.t('pc.title')}</StyledSettingsPageTitle>
        <StyledProfileButtonsWrapper defaultSection sectionName={'PARENTAL_LOCK'}>
          {parentalListData.map(item => (
            <ProfileItem
              onEnter={() => this.onEnter(item)}
              item={item}
              key={item.title}
              focusOnMouseEnter
            >
              {item.title}
            </ProfileItem>
          ))}
        </StyledProfileButtonsWrapper>
        <SupportInfo />
      </StyledSettingsPage>
    );
  }
}
